
<p-toast></p-toast>
<i class="pi pi-home" style="font-size: 2rem;margin-left:20px;cursor:pointer;" (click)="goHome()"></i>

<router-outlet></router-outlet>